<template>
  <div v-if="ready" class="home d-flex flex-column bg-dark-blue">
    <public-header></public-header>
    <div
      class="main-content align-self-center bg-white w-100 py-5 d-flex align-content-center py-5"
    >
      <div class="container align-self-center">
        <div class="d-flex align-content-center">
          <div class="row d-flex w-100">
            <div
              class="col-lg-6 flex-stretch d-flex align-content-center justify-content-center  order-lg-2"
            >
              <div>
                <img :src="require('@/assets/img/note.png')" />
              </div>
            </div>
            <div
              class="col-lg-6 flex-stretch d-flex justify-content-start flex-column py-5 order-lg-1"
            >
              <h1 class="text-left">
                Eliminate the clutter,<br />write in clear mind
              </h1>
              <button
                class="btn btn-light-blue mt-4"
                @click.prevent="$router.push('/dashboard')"
              >
                START WRITING
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-expand-lg footer align-self-end px-3 px-md-4">
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" to="/terms-and-conditions"
            >Terms and Conditions</router-link
          >
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/privacy-policy"
            >Privacy Policy</router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import PublicHeader from "@/layout/PublicHeader";
export default {
  name: "home",
  components: { PublicHeader },
  data() {
    return {
      ready: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 500);
  }
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
}
.main-content {
  position: relative;
  z-index: 1;
  min-height: 70vh;
}
h1 {
  font-size: 2em;
  color: #fff;
  font-weight: 900;
  // text-shadow: 8px 8px 24px rgba(0, 0, 0, 0.5);
}

@media (min-width: 800px) {
  h1 {
    font-size: 3em;
    color: black;
    font-weight: 900;
    // text-shadow: 4px 4px 20px rgba(0, 0, 0, 0.3);
  }
}
</style>
